module.exports = __webpack_public_path__ + "img/LS20130912_greenfire_027.c076e17f.jpg";